import type { ReactNode } from "react";
import Reveal from "./Reveal";

export default function SectionHead({
  eyebrow,
  title,
  desc,
  align = "left",
}: {
  eyebrow: string;
  title: ReactNode;
  desc?: string;
  align?: "left" | "center";
}) {
  const isCenter = align === "center";
  return (
    <Reveal>
      <div className={`mb-10 max-w-2xl ${isCenter ? "mx-auto text-center" : ""}`}>
        <p
          className={`mb-3 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-500 ${
            isCenter ? "justify-center" : ""
          }`}
        >
          <span className="h-px w-6 bg-primary-400" aria-hidden="true"></span>
          {eyebrow}
        </p>
        <h2 className="font-heading text-3xl font-black leading-snug text-foreground-950 md:text-4xl">{title}</h2>
        {desc && <p className="mt-4 text-base leading-relaxed text-foreground-600">{desc}</p>}
      </div>
    </Reveal>
  );
}